import { render, staticRenderFns } from "./TableCatSummary.vue?vue&type=template&id=4a1244a2&"
import script from "./TableCatSummary.vue?vue&type=script&lang=js&"
export * from "./TableCatSummary.vue?vue&type=script&lang=js&"
import style0 from "./TableCatSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports